<script context="module">
    let current;
    let currentLetter;
</script>

<script>
    import Icon from "fa-svelte";
    import { faPlay } from "@fortawesome/free-solid-svg-icons/faPlay";
    import { faPause } from "@fortawesome/free-solid-svg-icons/faPause";
    import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";
    import { afterUpdate, onMount } from "svelte";
    import { location } from "svelte-spa-router";

    export let audio;

    let audioControl;
    let playIcon = faPlay;
    let playing = false;
    let loading = false;
    afterUpdate(() => {
        currentLetter = $location.split("/letters/")[1];
    });
    $: if ($location.split("/letters/")[1] !== currentLetter) {
        playing = false;
    }
    $: {
        playIcon = playing ? faPause : faPlay;
        if (audioControl) {
            playing === true ? audioControl.play() : audioControl.pause();
        }
    }

    function stopOthers() {
        if (current && current !== audioControl) {
            current.pause();
        }
        current = audioControl;
    }

    function startStop() {
        playing = !playing;
    }
    function onStop() {
        playing = false;
    }
    function onError() {
        playIcon = faTimes;
        loading = false;
    }
    function onLoadStart() {
        loading = true;
    }
    function onLoadEnd() {
        loading = false;
    }
</script>

<audio
    bind:this={audioControl}
    on:play={stopOthers}
    on:pause={onStop}
    on:error={onError}
    on:loadstart={onLoadStart}
    on:loadeddata={onLoadEnd}
    src={audio} />

<button
    disabled={playIcon==faTimes}
    class="
    {loading?'animate-pulse':'customShadow'}
    {playIcon==faTimes?'cursor-default':'hover:bg-accent-100 hover:-translate-y-1 hover:scale-110 focus:bg-accent-100 focus:-translate-y-1 focus:scale-110'}
    w-8 h-8
    transition duration-500 ease-in-out 
    text-gray-600  border rounded-full transform"
on:click={startStop}><Icon icon={playIcon} /></button>
